import { isBetaFacility } from '@/service/facility/isBetaFacility';
import { CspViolationReportOptions, reportCspViolations } from '@/util/csp/reportCspViolations';
import type { BrowserLogger } from '@/util/logger/BrowserLogger';

export const CSP_VIOLATION_REPORT_FEATURE = 'reportCspViolationToDatadog';

export const createCspViolationReporter = (target: Document, logger: Pick<BrowserLogger, 'info'>) => {
  let currentFacilityId: number | undefined;
  let latestRequest = 0;
  let stopReporting = (): void => undefined;

  return async ({ facilityId, isL4A }: CspViolationReportOptions): Promise<void> => {
    if (facilityId === currentFacilityId) {
      return;
    }
    currentFacilityId = facilityId;
    const request = ++latestRequest;
    stopReporting();
    stopReporting = () => undefined;

    const enabled = await isBetaFacility(CSP_VIOLATION_REPORT_FEATURE);
    if (!enabled || request !== latestRequest) {
      return;
    }
    stopReporting = reportCspViolations(target, logger, { isL4A, facilityId });
  };
};
